(function ($) {
  Drupal.behaviors.myth_vs_reality_mpp_products_v1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var myth_reality = myth_reality || {};

      myth_reality.scrollPositions = [];
      myth_reality.init = function ($el) {
        // Set up all event listeners.
        myth_reality.ListenersSetup($el);
      };

      // Set particular classes and styles depending on MPP vs SPP.
      myth_reality.SetClassesStyles = function ($el) {
        if (isSPP) {
          var $spp = $el.closest('.spp-myth-vs-reality-v1-elc-nodeblock'),
            $header = $spp.children('.content').children('p').first(),
            $parent = $spp.parent();

          $spp.addClass('spp-myth-vs-reality-v1-elc-nodeblock--showing');
          $header.addClass('myth-vs-reality__header');
          $parent.addClass('spp-moisturizer-myths');
        } else {
          var $customTout = $el.closest('.product-grid-custom__tout');

          $customTout.addClass('product-grid-custom__tout--remove-margin-padding');
        }
      };

      // Gather scroll positions of each panel - used to flipp back panels on being scrolled out view.
      myth_reality.GatherScrollPositions = function ($el) {
        var scrollObj = {
          el: $el,
          scrollTop: $el.offset().top,
          position: $el.height() + $el.offset().top
        };

        myth_reality.scrollPositions.push(scrollObj);
        myth_reality.SetClassesStyles($el);
      };

      // Listener for flipping the panel from myth to reality
      myth_reality.PanelFlip = function ($flip_caller, $true_false_el) {
        $flip_caller.click(function () {
          if (isSPP) {
            var $text_overly_question = $(this).find('.js-textoverlay-question');

            if (!$text_overly_question.next().hasClass('myth-vs-reality__textoverlay-reality--fadein')) {
              myth_reality.FadeInReality($true_false_el);
            }
          } else {
            myth_reality.FadeInReality($true_false_el);
          }
        });
      };

      // Listener for flipping the panel back to the myth from reality
      myth_reality.PanelReturn = function ($el) {
        $el.once(function () {
          $(this).click(function () {
            var $text_overly_question = $(this).find('.js-textoverlay-question');

            if ($text_overly_question.next().hasClass('myth-vs-reality__textoverlay-reality--fadein')) {
              myth_reality.FadeInQuestion($(this));
            }
          });
        });
      };

      // Set up click events for the panels and scrolling.
      myth_reality.ListenersSetup = function ($el) {
        var $flip_caller = isSPP ? $el : $el.find('.js-btn-true-false'),
          $true_false_el = $el.find('.js-btn-true-false');

        // Flip
        myth_reality.PanelFlip($flip_caller, $true_false_el);
        // Flip back
        myth_reality.PanelReturn($el);
        // Gather scroll positions of each panel - used to flipp back panels on being scrolled out view.
        myth_reality.GatherScrollPositions($el);
      };

      // Fade back in the Myth and fade out the Reality.
      myth_reality.FadeInQuestion = function (_this) {
        var $text_overly_question = _this.find('.js-textoverlay-question'),
          $reality_border = $text_overly_question.prev(),
          $text_overlay_reality = $text_overly_question.next();

        $reality_border.removeClass('myth-vs-reality__reality-border--fadein');
        $text_overlay_reality.removeClass('myth-vs-reality__textoverlay-reality--fadein');
        // Animation delay.
        setTimeout(function () {
          _this.closest('.myth-vs-reality').removeClass('myth-vs-reality--flipped');
          $text_overlay_reality.removeClass('myth-vs-reality__textoverlay-reality--showing');
          $text_overly_question.removeClass('myth-vs-reality__textoverlay-question--hiding');
        }, 250);
        // Animation delay.
        setTimeout(function () {
          $text_overly_question.removeClass('myth-vs-reality__textoverlay-question--fadeout');
        }, 300);
      };

      // Fade out the Myth and fade in the Reality.
      myth_reality.FadeInReality = function (_this) {
        var $text_overly_question = _this.closest('.js-textoverlay-question'),
          $reality_border = $text_overly_question.prev(),
          $text_overlay_reality = $text_overly_question.next();

        $text_overly_question.addClass('myth-vs-reality__textoverlay-question--fadeout');
        // Animation delay.
        setTimeout(function () {
          _this.closest('.myth-vs-reality').addClass('myth-vs-reality--flipped');
          $text_overlay_reality.addClass('myth-vs-reality__textoverlay-reality--showing');
          $text_overly_question.addClass('myth-vs-reality__textoverlay-question--hiding');
        }, 250);
        // Animation delay.
        setTimeout(function () {
          $reality_border.addClass('myth-vs-reality__reality-border--fadein');
          $text_overlay_reality.addClass('myth-vs-reality__textoverlay-reality--fadein');
        }, 300);
      };

      // Check if a panel is within the view, if not, flipping it back to the Myth side where applicable.
      $(window).on('scroll', _.throttle(function () {
        if ($(window).width() > 767 && !isSPP) {
          var scrollPos = $(this).scrollTop(),
            viewPortHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            viewHeightWithScroll = viewPortHeight + scrollPos;

          $.each(myth_reality.scrollPositions, function (panel_index, panel_value) {
            if (scrollPos > panel_value.position || viewHeightWithScroll < panel_value.scrollTop) {
              myth_reality.FadeInQuestion(panel_value.el);
            }
          });
        }
      }, 250));

      // Determine if this is an MPP or SPP.
      var isSPP = $(context).find('.spp-myth-vs-reality-v1-elc-nodeblock').length > 0,
        $thismodule = $('.myth-vs-reality');

      $thismodule.each(function () {
        myth_reality.init($(this));
      });
    }
  };
})(jQuery);
